import type { Game } from '../../../../types/features/games';

export const filterGameReviewGames = (games: Game[], query: string): Game[] => {
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) {
    return games;
  }

  return games.filter((game) => [
    game.game_id,
    game.name,
    game.state_code || game.state,
    game.plu,
    game.tickets_per_pack,
    game.cost_per_ticket,
  ].some((value) => String(value ?? '').toLowerCase().includes(normalizedQuery)));
};
